import React from "react";
import {ROUTE_PATHS} from "Config/Router/Routes";
import {Link} from "react-router-dom";

interface Props{
    underlined?: boolean
}

export const LegalWarningLink : React.FC<Props> = (props) => {

    const isUnderlined = props.underlined ?? false

    return (
        <Link
            to={ROUTE_PATHS.LEGAL_WARNING}
            target={"_blank"}
            className={isUnderlined ? 'text-underline' : ''}
        >Aviso Legal</Link>
    )

}
